import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { EventHistoryBare } from 'SharedDir/declarations/ttp-event-history';
import { ttpEventHistoryUrl } from 'SharedDir/backend/endpoints/ttp-registries';

export default class TtpEventHistoryClass extends SimpleApi<EventHistoryBare, EventHistoryBare> {
  constructor() {
    super(ttpEventHistoryUrl);
  }
}
